import { AGENCY_COMMUNITY_V1 } from 'constants/endpoints';
import { METHOD_GET } from 'requests';
import { ApiRequestConfigType } from 'requests/index.types';

export const API_GET_agencyCommunitiesV1: ApiRequestConfigType = {
  method: METHOD_GET,
  url: AGENCY_COMMUNITY_V1,
  __typename: 'LegacyAPI',
};
